import { type ChangeEvent, useEffect, useState } from 'react';
import InputNumberLine from '../../../juristec-ui/core/InputNumberLine';
import ActionsGroup from '../../../juristec-ui/core/ActionsGroup';
import Button from '../../../juristec-ui/core/Button';
import { MainContainer, InfoContainer } from './styled';
import { type GptTokens } from '../../AssistentTokensBadge/AssistentTokensBadge';

interface AddTokensProps {
  close: () => void;
  submit: (qty: number) => void;
  getTokensInfo: () => Promise<GptTokens>;
}

const formatter = new Intl.NumberFormat('pt-BR', {
  notation: 'compact',
  compactDisplay: 'short',
});

const AddTokens = ({
  close, submit, getTokensInfo,
}: AddTokensProps) => {
  const [info, setInfo] = useState<GptTokens>({
    used: 0,
    limit: 0,
    bonus: 0,
  });
  const [qty, setQty] = useState<string | number>(0);

  useEffect(() => {
    (async () => {
      const res = await getTokensInfo();
      setInfo(res);
    })();
  }, []);

  const handleQty = (val: string) => {
    setQty(val);
  };

  const handleQtyChange = (e: ChangeEvent<HTMLInputElement>) => {
    handleQty(e.target.value);
  };

  const handleSubmit = () => {
    const val = Number(qty);
    if (val > 0) submit(val);
  };

  return (
    <>
      <MainContainer>
        <InfoContainer>
          <div>
            <span>
              {formatter.format(Math.min(info.used, info.limit))}
            </span>
            <span>Utilizados</span>
          </div>
          <div>
            <span>
              {formatter.format(info.limit)}
            </span>
            <span>Limite mensal</span>
          </div>
          <div>
            <span>
              {formatter.format(info.bonus)}
            </span>
            <span>Cortesia</span>
          </div>
        </InfoContainer>
        <InputNumberLine
          // @ts-expect-error not typed yet
          label="Quantidade"
          value={qty}
          onChange={handleQtyChange}
          setValue={handleQty}
          numContainerStyle={{ height: '50px' }}
        />
        <span>
          Tokens de cortesia são utilizados apenas quando o limite mensal é
          excedido e o saldo restante continua disponível nos meses seguintes.
        </span>
      </MainContainer>
      <ActionsGroup>
        <Button
          style={{ margin: '5px' }}
          onClick={close}
          variant="outlined"
          size="large"
        >
          Cancelar
        </Button>
        <Button
          style={{ margin: '5px' }}
          onClick={handleSubmit}
          size="large"
          disabled={!(Number(qty) > 0)}
        >
          Adicionar
        </Button>
      </ActionsGroup>
    </>
  );
};

export default AddTokens;
